import { EntrenadorJSON, Entrenador } from '../Entrenador/Entrenador';
import { TorneoListaBuenaFeOficial } from '../TorneoListaBuenaFeOficial/TorneoListaBuenaFeOficial';

export interface PlanillaPartidoOficialJSON {
  ppo_id: string | null;
  ppo_ppid: number;
  ppo_eqid: number;
  ppo_entid: number;
  entrenador: EntrenadorJSON;
  __delete: boolean;
}

export class PlanillaPartidoOficial {
  protected constructor(
    private id: string | null,
    private ppid: number,
    private eqid: number,
    private entid: number,
    private entrenador: Entrenador,
    private __delete: boolean
  ) {}

  static createFrom(
    id: string | null,
    ppid: number,
    eqid: number,
    entid: number,
    entrenador: Entrenador,
    __delete: boolean
  ) {
    return new this(id, ppid, eqid, entid, entrenador, __delete);
  }

  static createFromBuenaFe(planillaId: number, ofBuenaFe: TorneoListaBuenaFeOficial){
    return PlanillaPartidoOficial.createFrom(
      '',
      +planillaId,
      +ofBuenaFe.getTorneoListaBuenaFe()!.getEqid(),
      +ofBuenaFe.getEntid(),
      ofBuenaFe.getEntrenador()!,
      false
    );
  };

  isIdentifiedBy(anId: string): boolean {
    return this.id === anId;
  }

  isIdentifiedAs(aEntity: PlanillaPartidoOficial) {
    if (this.id) {
      return aEntity.isIdentifiedBy(this.id);
    } else {
      return false;
    }
  }

  static fromJSON(entity: PlanillaPartidoOficialJSON) {
    return PlanillaPartidoOficial.createFrom(
      entity.ppo_id,
      entity.ppo_ppid,
      entity.ppo_eqid,
      entity.ppo_entid,
      Entrenador.fromJSON(entity.entrenador),
      entity.__delete
    );
  }

  toJSON(): PlanillaPartidoOficialJSON {
    return {
      ppo_id: this.getId(),
      ppo_ppid: this.getPpid(),
      ppo_eqid: this.getEqid(),
      ppo_entid: this.getEntid(),
      entrenador: this.getEntrenador().toJSON(),
      __delete: this.__delete,
    };
  }

  getId(): string | null {
    return this.id;
  }

  getPpid(): number {
    return this.ppid;
  }

  getEqid(): number {
    return this.eqid;
  }

  getEntid(): number {
    return this.entid;
  }
  getEntrenador() {
    return this.entrenador;
  }

  setId(value: string | null): void {
    this.id = value;
  }

  setPpid(value: number): void {
    this.ppid = value;
  }

  setEqid(value: number): void {
    this.eqid = value;
  }

  setExcid(value: number): void {
    this.entid = value;
  }

  setDeleted(d: boolean) {
    this.__delete = d;
  }

  isActive(): boolean {
    return !this.__delete;
  }
}
